import { bindActionCreators } from 'redux';

import { setFailedValidations } from 'app/App/actions';
import editStatusSelector from 'app/App/selectors/editStatus';
import failedValidationsSelector from 'app/App/selectors/failedValidations';
import { saveAndVisitPageThunk } from 'app/Explorer/thunks';
import {
  apiResponseSelector,
  isCompassPageSelector,
  pagePayloadSelector,
  routeMappingSelector
} from 'app/Page/selectors';
import canEditParentFolderSelector from 'app/Can/selectors/canEditParentFolder';
import { visitComponent, visitPage } from 'app/Router/actions';
import connect from 'utils/store/connect';

import contractMapSelector from 'app/App/selectors/contractMap';
import { clearPageApiResponse } from './actions';
import PageButtonsList from './components/PageButtonsList';
import { saveAndPublishPageThunk, publishPageThunk, unpublishPageThunk } from './thunks';

/**
 * map redux state to react component properties
 * @param {object} state - redux state object
 * @returns {object} react props
 */
const mapStateToProps = state => ({
  apiResponse: apiResponseSelector(state),
  editStatus: editStatusSelector(state),
  failedValidations: failedValidationsSelector(state),
  isCompassPage: isCompassPageSelector(state),
  isReadonly: !canEditParentFolderSelector(state),
  pagePayload: pagePayloadSelector(state),
  routeMapping: routeMappingSelector(state),
  contractMap: contractMapSelector(state)
});

/**
 * map action creators to react component properties
 * @param {Function} dispatch - redux dispatch function
 * @returns {object} react props
 */
const mapDispatchToProps = function mapDispatchToProps(dispatch) {
  const bindables = {
    clearPageApiResponse,
    publishPage: publishPageThunk,
    savePage: saveAndVisitPageThunk,
    saveAndPublishPage: saveAndPublishPageThunk,
    setFailedValidations,
    unpublishPage: unpublishPageThunk,
    visitPage
  };
  return {
    ...bindActionCreators(bindables, dispatch),
    unboundVisitComponent: visitComponent,
    unboundVisitPage: visitPage
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PageButtonsList);
